import { forwardRef } from "react";
import clsx from "clsx";

import "./FreeTrialCard.css";
import { getPeriodString } from "../../lib/helpers/dateHelper";
import { PaymentData } from "../../lib/types";

type Props = {
  paymentData: PaymentData;
};
const PaymentCard = forwardRef<HTMLDivElement, Props>(
  ({ paymentData }, ref) => {
    return (
      <div className="FreeTrialCardWrapper">
        <div className="cardNoTrial" ref={ref}>
          <div>
            <h3 className={clsx("cardHeader", "semibold")}>Your Plan</h3>
          </div>

          <div className="priceCardNoTrial">
            <dl>
              <dt className="body-md">
                <span>
                  {`${getPeriodString(paymentData.period)?.adjective} Plan`}
                </span>
              </dt>
              <dd className="body-md">
                $13/mo billed yearly
              </dd>
            </dl>
          </div>
        </div>
      </div>
    );
  }
);

export default PaymentCard;
